import { IAppState } from '../common/state';

export const selectVillagesLink = (state: IAppState) => {
  return state.villagesLink;
};
